import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferBlock } from '../components/OfferBlock';
import { SalesFooter } from '../components/SalesFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full flex flex-col font-body text-dark bg-cream" data-id="element-202">
      <HeroSection data-id="element-203" />
      <OpeningHook data-id="element-204" />
      <ProblemSection data-id="element-205" />
      <FailedSolutions data-id="element-206" />
      <MechanismSection data-id="element-207" />
      <WhatYouGet data-id="element-208" />
      <WhoIsFor data-id="element-209" />
      <HowItWorks data-id="element-210" />
      <ProofSection data-id="element-211" />
      <FAQSection data-id="element-212" />
      <OfferBlock data-id="element-213" />
      <SalesFooter data-id="element-214" />
    </div>;
}